const measurementEn = {
	measurementTable: 'Measurement',
	name: 'Name',
	measurementEditForm: 'Measurement',
	basic: 'Basic',
	table_name: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	role: 'Role',
	type: 'Type',
	category: 'Category',
	uom: 'UOM',
	components: 'Components',
	userGroup: 'User Group'
};

export default measurementEn;
